import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type
const activeAssetsSlice = createSlice({
  name: "activeAssets",

  initialState: { activeAssets: [], activeAssetsLoader: false },
  reducers: {
    setAllActiveAssets: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.activeAssets = payload;
    },
    setAllActiveAssetsLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.activeAssetsLoader = payload;
    },
    resetAllActiveAssets: (state) => {
      state.activeAssets = [];
    },
  },
});

export const {
  setAllActiveAssets,
  resetAllActiveAssets,
  setAllActiveAssetsLoader,
} = activeAssetsSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default activeAssetsSlice.reducer;
